module.exports = __webpack_public_path__ + "static/media/zipIcon.c8fdd7c0.svg";